export const ghgCategories = {
	// Scope 1
	'Stationary Combustion': 'Stationary Combustion',
	'Mobile Combustion': 'Mobile Combustion',
	'Process Emissions': 'Process Emissions',
	'Fugitive Emissions': 'Fugitive Emissions',
	// Scope 2
	'Purchased Electricity': 'Purchased Electricity',
	'Purchased Steam, Heat, or Cooling': 'Purchased Steam, Heat, or Cooling',
	// Scope 3
	'Purchased Goods and Services': 'Purchased Goods and Services',
	'Capital Goods': 'Capital Goods',
	'Fuel and Energy Related Activities': 'Fuel and Energy Related Activities',
	'Transportation and Distribution (Upstream)':
		'Transportation and Distribution (Upstream)',
	'Waste Generated in Operations': 'Waste Generated in Operations',
	'Business Travel': 'Business Travel',
	'Employee Commuting': 'Employee Commuting',
	'Leased Assets (Upstream)': 'Leased Assets (Upstream)',
	'Transportation and Distribution (Downstream)':
		'Transportation and Distribution (Downstream)',
	'Processing of Sold Products': 'Processing of Sold Products',
	'Use of Sold Products': 'Use of Sold Products',
	'End-of-Life Treatment of Sold Products':
		'End-of-Life Treatment of Sold Products',
	'Leased Assets (Downstream)': 'Leased Assets (Downstream)',
	Franchises: 'Franchises',
	Investments: 'Investments',
	unknown: 'Unknown',
	Others: 'Other categories',
}
